import { CopyButton } from "~/components/CopyableField"
import type { ComponentProps } from "react"
import { cn } from "~/lib/utils"

export function CodeBlock({
	className,
	children,
	wrap = true,
	copyText,
	size = "default",
	...props
}: ComponentProps<"pre"> & {
	wrap?: boolean
	copyText?: string
	size?: "sm" | "default" | "lg"
}) {
	return (
		<div className="relative min-w-0">
			{copyText !== undefined && (
				<div className="absolute right-2 top-2">
					<CopyButton value={copyText} label="contents" size="icon-xs" />
				</div>
			)}
			<pre
				className={cn(
					"overflow-auto rounded-lg border border-stroke bg-background-secondary p-3 font-mono text-xs leading-relaxed text-text-sub",
					size === "sm"
						? "max-h-40"
						: size === "lg"
							? "max-h-[60vh]"
							: "max-h-80",
					wrap && "whitespace-pre-wrap break-words",
					copyText !== undefined && "pr-12",
					className
				)}
				{...props}
			>
				{children}
			</pre>
		</div>
	)
}
